/**
@ngdoc filter
@name filterCategorySearch

@description
Returns all objects of input which name property contains viewValue OR delimiter property is true.
*/
angular.module('app').filter('termCategoryAutocomplete', [function() {
    return function(input, viewValue) {
    	if(!angular.isDefined(viewValue) || viewValue==''){
    		return input;
    	}
    	return input.filter(function(el) {
			return (el.delimiter == true
				|| (el.name.toLowerCase().indexOf(viewValue.toLowerCase()) !== -1 && el.recentSearch != true));
		});
    }
}]);


